let radioButtons = document.querySelectorAll(".PRPSelectionButton");
let PRPVariant = 'null';

radioButtons.forEach(button => button.addEventListener('click', prpSelected, {passive: true}));
radioButtons.forEach(button => button.addEventListener('touchstart', prpSelected, {passive: true}));

function prpSelected() {
    PRPVariant = this.defaultValue;
}

async function prpChecked() {
    if (PRPVariant != 'null') {
        let formData = { items: [{ id: PRPVariant, quantity: 1 }] };
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            await response.json();
        } catch (err) {
            console.error('PRP failed', err);
        }
    }
}
